import React from "react";
//import IcomoonReact from "icomoon-react";
import IcoMoon from "react-icomoon";
import iconSet from "./selection.json";
import { icons } from "assets/icons";

const Icon = (props) => {
  const { color, size = "100%", icon, className = "" } = props;

  return (
/*
    <IcomoonReact
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={icon}
    />  
*/

  <IcoMoon 
    className={className}
    iconSet={iconSet}
    color={color}
    size={size}
    icon={icon} 
  />

/*  
<p>{icon}</p>
*/

  );
};


export default Icon;
